/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModal_QueryVariables = {
    personId?: string | null | undefined;
    taskId?: number | null | undefined;
    projectId?: number | null | undefined;
    idleTimeId?: number | null | undefined;
    fetchProgramInfo: boolean;
};
export type TimeRegistrationModal_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationModal_viewer">;
    } | null;
};
export type TimeRegistrationModal_Query = {
    readonly response: TimeRegistrationModal_QueryResponse;
    readonly variables: TimeRegistrationModal_QueryVariables;
};



/*
query TimeRegistrationModal_Query(
  $personId: ID
  $taskId: Int
  $projectId: Int
  $idleTimeId: Int
  $fetchProgramInfo: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "time_registration_modal")
    ...TimeRegistrationModal_viewer_1P1eiZ
    id
  }
}

fragment ProjectIndicator_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment TimeRegistrationModalIntegrations_company on Company {
  harvestEnabled
  unit4Enabled
}

fragment TimeRegistrationModalIntegrations_person on Person {
  harvestUser
  unit4User
}

fragment TimeRegistrationModalIntegrations_project on ProjectType {
  id
  harvestProject {
    id
  }
  unit4Project {
    activitiesEnabled
    id
  }
}

fragment TimeRegistrationModalTaskInfo_task on Task {
  id
  name
  estimateForecastMinutes
  totalMinutesRegistered
  project {
    estimationUnit
    minutesPerEstimationPoint
    id
  }
}

fragment TimeRegistrationModal_viewer_1P1eiZ on Viewer {
  backendId
  actualPersonId
  company {
    id
    sageIntacctEnabled
    lockedPeriodYear
    lockedPeriodMonth
    lockedPeriodDay
    roles(includeDisabled: false, backendProjectId: $projectId) {
      edges {
        node {
          id
          name
        }
      }
    }
    ...TimeRegistrationModalIntegrations_company
    person(id: $personId) {
      id
      role {
        id
        name
      }
      email
      submitLockedDateYear
      submitLockedDateMonth
      submitLockedDateDay
      excludeFromCompanyLockedPeriod
      startDate
      endDate
      createdAt
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      ...TimeRegistrationModalIntegrations_person
    }
  }
  task(backendId: $taskId) {
    id
    name
    role {
      id
      name
    }
    companyTaskId
    estimateForecastMinutes
    totalMinutesRegistered
    timeLeft
    billable
    startYear
    startMonth
    startDay
    deadlineYear
    deadlineMonth
    deadlineDay
    statusColumnV2 {
      category
      id
    }
    assignedPersons {
      id
    }
    project {
      id
      name
      status
      fullAccessToProject
      companyProjectId
      customProjectId
      projectColor
      billable
      projectStartYear
      projectStartMonth
      projectStartDay
      projectEndYear
      projectEndMonth
      projectEndDay
      projectRoles {
        id
        name
      }
      projectPerson(personId: $personId) {
        role {
          id
          name
        }
        id
      }
      programBudgetType @include(if: $fetchProgramInfo)
  isProgramRevenueLocked @include(if: $fetchProgramInfo)
  program @include(if: $fetchProgramInfo) {
        name
        prefix
        members {
          edges {
            node {
              role
              person {
                id
              }
              id
            }
          }
        }
        id
      }
      ...ProjectIndicator_project
      ...TimeRegistrationModalIntegrations_project
    }
    ...TimeRegistrationModalTaskInfo_task
  }
  project(backendId: $projectId) {
    id
    name
    status
    fullAccessToProject
    companyProjectId
    customProjectId
    projectColor
    billable
    projectStartYear
    projectStartMonth
    projectStartDay
    projectEndYear
    projectEndMonth
    projectEndDay
    client {
      name
      id
    }
    projectRoles {
      id
      name
    }
    projectPerson(personId: $personId) {
      role {
        id
        name
      }
      id
    }
    programBudgetType @include(if: $fetchProgramInfo)
  isProgramRevenueLocked @include(if: $fetchProgramInfo)
  program @include(if: $fetchProgramInfo) {
      name
      prefix
      members {
        edges {
          node {
            role
            person {
              id
            }
            id
          }
        }
      }
      id
    }
    ...ProjectIndicator_project
    ...TimeRegistrationModalIntegrations_project
  }
  idleTime(backendId: $idleTimeId) {
    id
    isInternalTime
    name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "idleTimeId",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchProgramInfo",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "time_registration_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"time_registration_modal\")"
},
v3 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v9 = [
  (v4/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "projectRoles",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activitiesEnabled",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "condition": "fetchProgramInfo",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "programBudgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isProgramRevenueLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "program",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectServiceProgramMemberType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "role",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": (v9/*: any*/),
                      "storageKey": null
                    },
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeRegistrationModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchProgramInfo",
                "variableName": "fetchProgramInfo"
              },
              {
                "kind": "Variable",
                "name": "idleTimeId",
                "variableName": "idleTimeId"
              },
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              {
                "kind": "Variable",
                "name": "taskId",
                "variableName": "taskId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TimeRegistrationModal_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimeRegistrationModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backendId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "backendProjectId",
                    "variableName": "projectId"
                  },
                  {
                    "kind": "Literal",
                    "name": "includeDisabled",
                    "value": false
                  }
                ],
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit4Enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submitLockedDateYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submitLockedDateMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submitLockedDateDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "excludeFromCompanyLockedPeriod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "monday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tuesday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wednesday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thursday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "friday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "saturday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sunday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "harvestUser",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit4User",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "backendId",
                "variableName": "taskId"
              }
            ],
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyTaskId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimateForecastMinutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalMinutesRegistered",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeLeft",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deadlineYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deadlineMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deadlineDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "statusColumnV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "category",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "assignedPersons",
                "plural": true,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v8/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimationUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minutesPerEstimationPoint",
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "backendId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v8/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "backendId",
                "variableName": "idleTimeId"
              }
            ],
            "concreteType": "IdleTime",
            "kind": "LinkedField",
            "name": "idleTime",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInternalTime",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TimeRegistrationModal_Query",
    "operationKind": "query",
    "text": "query TimeRegistrationModal_Query(\n  $personId: ID\n  $taskId: Int\n  $projectId: Int\n  $idleTimeId: Int\n  $fetchProgramInfo: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"time_registration_modal\")\n    ...TimeRegistrationModal_viewer_1P1eiZ\n    id\n  }\n}\n\nfragment ProjectIndicator_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment TimeRegistrationModalIntegrations_company on Company {\n  harvestEnabled\n  unit4Enabled\n}\n\nfragment TimeRegistrationModalIntegrations_person on Person {\n  harvestUser\n  unit4User\n}\n\nfragment TimeRegistrationModalIntegrations_project on ProjectType {\n  id\n  harvestProject {\n    id\n  }\n  unit4Project {\n    activitiesEnabled\n    id\n  }\n}\n\nfragment TimeRegistrationModalTaskInfo_task on Task {\n  id\n  name\n  estimateForecastMinutes\n  totalMinutesRegistered\n  project {\n    estimationUnit\n    minutesPerEstimationPoint\n    id\n  }\n}\n\nfragment TimeRegistrationModal_viewer_1P1eiZ on Viewer {\n  backendId\n  actualPersonId\n  company {\n    id\n    sageIntacctEnabled\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    roles(includeDisabled: false, backendProjectId: $projectId) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    ...TimeRegistrationModalIntegrations_company\n    person(id: $personId) {\n      id\n      role {\n        id\n        name\n      }\n      email\n      submitLockedDateYear\n      submitLockedDateMonth\n      submitLockedDateDay\n      excludeFromCompanyLockedPeriod\n      startDate\n      endDate\n      createdAt\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      ...TimeRegistrationModalIntegrations_person\n    }\n  }\n  task(backendId: $taskId) {\n    id\n    name\n    role {\n      id\n      name\n    }\n    companyTaskId\n    estimateForecastMinutes\n    totalMinutesRegistered\n    timeLeft\n    billable\n    startYear\n    startMonth\n    startDay\n    deadlineYear\n    deadlineMonth\n    deadlineDay\n    statusColumnV2 {\n      category\n      id\n    }\n    assignedPersons {\n      id\n    }\n    project {\n      id\n      name\n      status\n      fullAccessToProject\n      companyProjectId\n      customProjectId\n      projectColor\n      billable\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      projectRoles {\n        id\n        name\n      }\n      projectPerson(personId: $personId) {\n        role {\n          id\n          name\n        }\n        id\n      }\n      programBudgetType @include(if: $fetchProgramInfo)\n  isProgramRevenueLocked @include(if: $fetchProgramInfo)\n  program @include(if: $fetchProgramInfo) {\n        name\n        prefix\n        members {\n          edges {\n            node {\n              role\n              person {\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ...ProjectIndicator_project\n      ...TimeRegistrationModalIntegrations_project\n    }\n    ...TimeRegistrationModalTaskInfo_task\n  }\n  project(backendId: $projectId) {\n    id\n    name\n    status\n    fullAccessToProject\n    companyProjectId\n    customProjectId\n    projectColor\n    billable\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    client {\n      name\n      id\n    }\n    projectRoles {\n      id\n      name\n    }\n    projectPerson(personId: $personId) {\n      role {\n        id\n        name\n      }\n      id\n    }\n    programBudgetType @include(if: $fetchProgramInfo)\n  isProgramRevenueLocked @include(if: $fetchProgramInfo)\n  program @include(if: $fetchProgramInfo) {\n      name\n      prefix\n      members {\n        edges {\n          node {\n            role\n            person {\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    ...ProjectIndicator_project\n    ...TimeRegistrationModalIntegrations_project\n  }\n  idleTime(backendId: $idleTimeId) {\n    id\n    isInternalTime\n    name\n  }\n}\n"
  }
};
})();
(node as any).hash = '0e3a80b7841347f2bbfee1717c80cd43';
export default node;
